import React from 'react';
import { TableRow, TableCell, Skeleton, Box } from '@mui/material';

const TableRowSkeleton = ({ columns = [] }) => {
  return (
    <TableRow>
      {columns.map((column, index) => (
        <TableCell
          key={`skeleton-${index}`}
          align={column.align || 'left'}
          style={{ ...(column.cellStyle || {}) }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton
              variant="text"
              width="80%"
              height={20}
              animation="wave"
            />
          </Box>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableRowSkeleton;
